import { object, number } from "yup";

const updateRoomSchema = object().shape({
  cost: number()
    .typeError("房租必須是數字")
    .integer("房租必須是整數")
    .test("rent >=0", "房租必須至少為零", (value) => value >= 0)
    .required("請填寫房租"),
});

export { updateRoomSchema };
